<div
  [ngClass]="'period-' + period"
  [style.backgroundColor]="color"
  [style.height.px]="size"
  [style.left.px]="xPos"
  [style.top.px]="yPos"
  [style.width.px]="size"
  class="star"></div>
